<template>
  <el-dropdown trigger="click" @command="handleVersionChange">
    <div class="icon-conversion">
      <svg-icon icon-class="conversion" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item of versionOptions"
        :key="item.value"
        :disabled="currentVersion===item.value"
        :command="item.value"
      >
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateSystemVersion } from '@/api/setting/config';

const versionOptions = ['Stable', 'Beta', 'Alpha'];

function normalizeVersion (version) {
  if (!version || typeof version !== 'string') {
    return 'Stable';
  }
  const normalizedVersion = version.charAt(0).toUpperCase() + version.slice(1).toLowerCase();
  return versionOptions.includes(normalizedVersion) ? normalizedVersion : 'Stable';
}

export default {
  data () {
    return {
      versionOptions: [
        { label: '稳定版', value: 'Stable' },
        { label: '尝鲜版', value: 'Beta' },
        { label: '测试版', value: 'Alpha' }
      ]
    };
  },
  computed: {
    ...mapGetters(['user']),
    currentVersion () {
      return normalizeVersion(this.user && this.user.softVersion);
    }
  },
  methods: {
    async handleVersionChange (version) {
      this.$confirm('版本切换后需要重新登录，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateSystemVersion({ version })
          .then(() => {
            this.$store.dispatch('user/logout');
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          });
      }).catch(() => {
        this.version = this.form.version;
      });
    }
  }
};
</script>

<style scoped>
.icon-conversion {
  cursor: pointer;
  color: #333;
  font-size: 24px;
}
</style>
